import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ScreenSizeService, ViewMode } from '../../services/screen-size';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { BefragungBannerComponent } from '../befragung-banner/befragung-banner.component';

@Component({
  selector: 'now-wbsuche-lib-responsive-context-info-header',
  templateUrl: './responsive-context-info-header.component.html',
  styleUrls: ['./responsive-context-info-header.component.scss'],
  imports: [CommonModule, BreadcrumbComponent, BefragungBannerComponent]
})
export class ResponsiveContextInfoHeaderComponent {
  private readonly screenSizeService = inject(ScreenSizeService);

  public subtitle =
    'Entdecken Sie Ihre Weiterbildungsmöglichkeiten mithilfe unserer umfassenden Suche.';

  public isDesktop$ = this.screenSizeService.onlyLargeDesktop$;

  public isTabletOrBigger$ = this.screenSizeService.rangeFrom$(ViewMode.TABLET);
  public isPhabletOrBigger$ = this.screenSizeService.rangeFrom$(ViewMode.PHABLET);
}
